// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mountain-top';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m4.688 17.437 5.707-9.06a.84.84 0 0 1 1.335 0l5.707 9.06z' />
    <path d='m4.688 17.437-4.125.008 4.5-6.75 2.137 2.76m1.283-2.04 2.557 1.717 2.58-1.762m-2.557-3.323V.555m0 0h5.392a.397.397 0 0 1 .353.225.413.413 0 0 1-.045.412l-.855 1.058a.398.398 0 0 0 0 .487l.855 1.088a.405.405 0 0 1 .045.412.397.397 0 0 1-.353.225h-5.392' />
  </g>
);

export const viewBox = '0 0 18 18';
